import { apiUtil, UnpackPromise } from '@cmg/common';
import { AxiosResponse } from 'axios';

import {
  OfferingParticipationResponse,
  OfferingParticipationUpload,
} from '../../../types/domain/participation-sets/participation-sets';
import { dlgwApiClient } from '../apiClient';

export const uploadParticipationSet = (params: OfferingParticipationUpload) => {
  const formData = new FormData();
  formData.append('offeringId', params.offeringId);
  formData.append('file', params.file);
  formData.append('mappings', JSON.stringify(params.mappings));
  return dlgwApiClient
    .post<OfferingParticipationUpload, AxiosResponse<OfferingParticipationResponse>>(
      '/participationsets',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    .then(apiUtil.transformSuccessResponse)
    .catch(apiUtil.transformFailureResponse);
};
export type UploadParticipationSetsFromCsvFileResponse = UnpackPromise<
  ReturnType<typeof uploadParticipationSet>
>;
